import { PlatformIntegration } from '../../platform/platform-integration';
import { IAuthorization, IPlatformAuthorizer } from '@studyportals/scholarships-editor-integration';

export class PlatformAuthorizerDecoratorUiLoader implements IPlatformAuthorizer {
	private readonly target: IPlatformAuthorizer;

	public constructor(target: IPlatformAuthorizer) {
		this.target = target;
	}

	public async authorizeOrganizationQuery(): Promise<IAuthorization> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.authorizeOrganizationQuery();
		} finally {
			loader.dispose();
		}
	}

	public async authorizeBodyQuery(): Promise<IAuthorization> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.authorizeBodyQuery();
		} finally {
			loader.dispose();
		}
	}
}
